import { authRoles } from './auth/authRoles';

export const navigationsTypeB = [
  {
    name: 'HOME',
    path: '/storehome',
    icon: 'home',
  },
  {
    name: '店舗',
    icon: 'storefront',
    children: [
      {
        name: '新規店舗登録',
        path: '/storeregist',
      },
      {
        name: '登録編集・解除',
        path: '/storeedit',
      },
      {
        name: 'アプリ営業時間設定',
        path: '/storebusinesshours',
      },
    ],
  },
]

export const navigations = [
  {
    name: 'HOME',
    path: '/home',
    icon: 'home',
  },
  // {
  //   name: '店舗検索',
  //   path: '/shop/search',
  //   icon: 'search', //MatxVerticalNav.jsx iconない場合の点
  // },
  //{
  //  name: '現金管理',
  //  path: '/cash',
  //  icon: 'local_atm_icon',
  //},
  {
    name: '売上',
    icon: 'trending_up',
    children: [
      //{
      //  name: '売上',
      //  path: '/sales/search',
      //},
      {
        name: '期間売上',
        path: '/salesterm',
      },
      {
        name: '時間帯売上',
        path: '/salestimezone',
      },
      {
        name: 'カテゴリ別売上',
        path: '/salescategory',
      },
      {
        name: '商品別売上',
        path: '/salesitems',
      }
      //{
      //  name: '日別詳細',
      //  path: '/salesdaily',
      //},
    ],
  },
  {
    name: '取引履歴（電子ジャーナル）',
    path: '/tradinghistory',
    icon: 'receipt_long',
  },
  {
    name: '日次処理',
    icon: 'fact_check',
    children: [
      {
        name: '日次・月次締め',
        path: '/dailyclosing',
      },
      {
        name: 'VOID処理',
        path: '/voidlist',
      }
    ],
  },
  // {
  //   name: 'IR開示情報',
  //   path: '/ir',
  //   icon: 'assignment_icon',
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: '店舗分析',
  //   icon: 'dvr_icon',
  //   children: [
  //     {
  //       name: '売上比較',
  //       path: '/analytics-sales',
  //     },
  //     {
  //       name: '非既存店・既存店分析',
  //       path: '/analytics-shop',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: 'メニュー売上分析',
  //   icon: 'restaurant_icon',
  //   children: [
  //     {
  //       name: 'オーダー率ランキング',
  //       path: '/ranking-order',
  //     },
  //     {
  //       name: '部門別ABC表',
  //       path: '/dept-abc',
  //     },
  //     {
  //       name: 'ABC表',
  //       path: '/abc',
  //     },
  //     {
  //       name: 'ﾒﾆｭｰ別点数ﾗﾝｷﾝｸﾞ[日別]',
  //       path: '/ranking-menu',
  //     },
  //     {
  //       name: '店舗別メニュー別構成比',
  //       path: '/menu-ratio',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: '仕入明細',
  //   icon: 'print_icon',
  //   children: [
  //     {
  //       name: '仕入明細表',
  //       path: '/purchase-detail',
  //     },
  //     {
  //       name: '店舗仕入実績',
  //       path: '/purchase-record',
  //     },
  //     {
  //       name: '月別業態地区別仕入数量',
  //       path: '/purchase-quantity',
  //     },
  //     {
  //       name: '店舗別食材売上推移（月次）',
  //       path: '/purchase-transition',
  //     },
  //     {
  //       name: '食材売上額・生餃子\n出荷数前年比（店・月別）',
  //       path: '/purchase-shipping',
  //     },
  //     {
  //       name: '食材売上検証',
  //       path: '/purchase-inspect',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: '営業日報',
  //   icon: 'edit_icon',
  //   children: [
  //     {
  //       name: '入力',
  //       path: '/report-input',
  //     },
  //     {
  //       name: '閲覧',
  //       path: '/report-browse',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: 'キングオブ大阪王将',
  //   icon: 'star_icon',
  //   children: [
  //     {
  //       name: '売上部門',
  //       path: '/king-order',
  //     },
  //     {
  //       name: '客数部門',
  //       path: '/king-customer',
  //     },
  //     {
  //       name: '餃子部門',
  //       path: '/king-gyoza',
  //     },
  //     {
  //       name: '販促部門',
  //       path: '/king-sales',
  //     },
  //     {
  //       name: '店舗運営力部門',
  //       path: '/king-manage',
  //     },
  //     {
  //       name: 'ナホオーダー',
  //       path: '/king-naho',
  //     },
  //     {
  //       name: '指定食材減点',
  //       path: '/king-food',
  //     },
  //     {
  //       name: '総合順位',
  //       path: '/king-rank',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////

  // {
  //   name: '開発用画面',
  //   path: '/develop',//dashboardの中に
  // },
  // {
  //   name: 'Develop',
  //   children: [
  //     {
  //       name: 'Dashboard', //サイドバーの名前表示
  //       path: '/dashboard', //DashboardRoutes.jsの./Analytics2
  //       icon: 'dashboard',
  //     },
  //     {
  //       name: 'Alternative',
  //       path: '/alternative',
  //       icon: 'analytics',
  //     },
  //     {
  //       name: 'Inventory Management',
  //       path: '/inventory-management',
  //       icon: 'store',
  //     },
  //     {
  //       name: 'Customers',
  //       icon: 'people',
  //       children: [
  //         {
  //           name: 'Customer List',
  //           path: '/pages/customer-list',
  //           iconText: 'CL',
  //         },
  //         {
  //           name: 'View Customer',
  //           path: '/pages/view-customer',
  //           iconText: 'VC',
  //         },
  //         {
  //           name: 'New Customer',
  //           path: '/pages/new-customer',
  //           iconText: 'NC',
  //         },
  //         {
  //           name: 'User Profile',
  //           path: '/page-layouts/user-profile',
  //           // icon: 'person',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Products',
  //       icon: 'shopping_cart',
  //       children: [
  //         {
  //           name: 'Product List',
  //           path: '/pages/product-list',
  //           iconText: 'PL',
  //         },
  //         {
  //           name: 'View Product',
  //           path: '/pages/view-product',
  //           iconText: 'VP',
  //         },
  //         {
  //           name: 'New Product',
  //           path: '/pages/new-product',
  //           iconText: 'NP',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Orders',
  //       icon: 'folder',
  //       children: [
  //         {
  //           name: 'Order List',
  //           path: '/pages/order-list',
  //           iconText: 'OL',
  //         },
  //         {
  //           name: 'View Order',
  //           path: '/invoice/fdskfjdsuoiucrwevbgd',
  //           iconText: 'VO',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Help Center',
  //       icon: 'help',
  //       children: [
  //         {
  //           name: 'FAQ 1',
  //           path: '/pages/faq-1',
  //           iconText: 'F1',
  //         },
  //         {
  //           name: 'FAQ 2',
  //           path: '/pages/faq-2',
  //           iconText: 'F2',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Pricing',
  //       icon: 'money',
  //       children: [
  //         {
  //           name: 'Pricing 1',
  //           iconText: 'P1',
  //           path: '/others/pricing-1',
  //         },
  //         {
  //           name: 'Pricing 2',
  //           iconText: 'P2',
  //           path: '/others/pricing-2',
  //         },
  //         {
  //           name: 'Pricing 3',
  //           iconText: 'P3',
  //           path: '/others/pricing-3',
  //         },
  //         {
  //           name: 'Pricing 4',
  //           iconText: 'P4',
  //           path: '/others/pricing-4',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'User List',
  //       icon: 'people',
  //       children: [
  //         {
  //           name: 'User List 1',
  //           path: '/pages/user-list-1',
  //           iconText: 'U1',
  //         },
  //         {
  //           name: 'User List 2',
  //           path: '/pages/user-list-2',
  //           iconText: 'U2',
  //         },
  //         {
  //           name: 'User List 3',
  //           path: '/pages/user-list-3',
  //           iconText: 'U3',
  //         },
  //         {
  //           name: 'User List 4',
  //           path: '/pages/user-list-4',
  //           iconText: 'U3',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Forms',
  //       icon: 'description',
  //       children: [
  //         {
  //           name: 'Order Form',
  //           path: '/forms/order-form',
  //           iconText: 'OF',
  //         },
  //         {
  //           name: 'Invoice Form',
  //           path: '/forms/invoice-form',
  //           iconText: 'IF',
  //         },
  //         {
  //           name: 'Property Listing Form',
  //           path: '/forms/property-listing-form',
  //           iconText: 'PF',
  //         },
  //         {
  //           name: 'Basic',
  //           path: '/forms/basic',
  //           iconText: 'B',
  //         },
  //         {
  //           name: 'Editor',
  //           path: '/forms/editor',
  //           iconText: 'E',
  //         },
  //         {
  //           name: 'Upload',
  //           path: '/forms/upload',
  //           iconText: 'U',
  //         },
  //         {
  //           name: 'Wizard',
  //           path: '/forms/wizard',
  //           iconText: 'W',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Matx List',
  //       icon: 'list',
  //       children: [
  //         {
  //           name: 'Infinite Scroll',
  //           path: '/infinite-scroll',
  //           iconText: 'I',
  //         },
  //         {
  //           name: 'List',
  //           path: '/matx-list',
  //           iconText: 'L',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Session/Auth',
  //       icon: 'security',
  //       children: [
  //         {
  //           name: 'Sign in',
  //           iconText: 'SI',
  //           path: '/session/signin',
  //         },
  //         {
  //           name: 'Sign up',
  //           iconText: 'SU',
  //           path: '/session/signup',
  //         },
  //         {
  //           name: 'Forgot Password',
  //           iconText: 'FP',
  //           path: '/session/forgot-password',
  //         },
  //         {
  //           name: 'Error',
  //           iconText: '404',
  //           path: '/session/404',
  //         },
  //       ],
  //     },

  //     {
  //       label: 'Apps',
  //       type: 'label',
  //     },
  //     {
  //       name: 'Ecommerce',
  //       icon: 'shopping_basket',
  //       children: [
  //         {
  //           name: 'Shop',
  //           path: '/ecommerce/shop',
  //           iconText: 'S',
  //         },
  //         {
  //           name: 'Cart',
  //           path: '/ecommerce/cart',
  //           iconText: 'C',
  //         },
  //         {
  //           name: 'Checkout',
  //           path: '/ecommerce/checkout',
  //           iconText: 'CO',
  //         },
  //       ],
  //     },

  //     {
  //       name: 'APP',
  //       children: [
  //         {
  //           name: 'Scrum Board',
  //           // icon: 'group_work',
  //           path: '/scrum-board/c5d7498bbcb84d81fc7454448871ac6a6e',
  //         },
  //         {
  //           name: 'Invoice Builder',
  //           // icon: 'receipt',
  //           path: '/invoice/list',
  //         },
  //         {
  //           name: 'Calendar',
  //           // icon: 'date_range',
  //           path: '/calendar',
  //         },
  //         {
  //           name: 'Chat',
  //           // icon: 'chat',
  //           path: '/chat',
  //         },
  //         {
  //           name: 'Inbox',
  //           // icon: 'inbox',
  //           path: '/inbox',
  //         },
  //         {
  //           name: 'Todo',
  //           // icon: 'center_focus_strong',
  //           path: '/todo/list',
  //         },
  //       ]
  //     },


  //     {
  //       label: 'Components',
  //       type: 'label',
  //     },
  //     {
  //       name: 'Components',
  //       icon: 'favorite',
  //       badge: { value: '30+', color: 'secondary' },
  //       children: [
  //         {
  //           name: 'Auto Complete',
  //           path: '/material/autocomplete',
  //           iconText: 'A',
  //         },
  //         {
  //           name: 'Buttons',
  //           path: '/material/buttons',
  //           iconText: 'B',
  //         },
  //         {
  //           name: 'Checkbox',
  //           path: '/material/checkbox',
  //           iconText: 'C',
  //         },
  //         {
  //           name: 'Dialog',
  //           path: '/material/dialog',
  //           iconText: 'D',
  //         },
  //         {
  //           name: 'Drag and Drop',
  //           iconText: 'D',
  //           path: '/others/drag-and-drop',
  //         },
  //         {
  //           name: 'Expansion Panel',
  //           path: '/material/expansion-panel',
  //           iconText: 'E',
  //         },
  //         {
  //           name: 'Form',
  //           path: '/material/form',
  //           iconText: 'F',
  //         },
  //         {
  //           name: 'Icons',
  //           path: '/material/icons',
  //           iconText: 'I',
  //         },
  //         {
  //           name: 'Menu',
  //           path: '/material/menu',
  //           iconText: 'M',
  //         },
  //         {
  //           name: 'Progress',
  //           path: '/material/progress',
  //           iconText: 'P',
  //         },
  //         {
  //           name: 'Radio',
  //           path: '/material/radio',
  //           iconText: 'R',
  //         },
  //         {
  //           name: 'Switch',
  //           path: '/material/switch',
  //           iconText: 'S',
  //         },
  //         {
  //           name: 'Slider',
  //           path: '/material/slider',
  //           iconText: 'S',
  //         },
  //         {
  //           name: 'Snackbar',
  //           path: '/material/snackbar',
  //           iconText: 'S',
  //         },
  //         {
  //           name: 'Table',
  //           path: '/material/table',
  //           iconText: 'T',
  //         },
  //         {
  //           name: 'Map',
  //           // icon: 'add_location',
  //           path: '/map',
  //         },
  //         {
  //           name: 'Left Sidebar Card',
  //           path: '/page-layouts/Left-sidebar-card',
  //           // icon: 'vertical_split',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Utilities',
  //       icon: 'format_list_bulleted',
  //       children: [
  //         {
  //           name: 'Color',
  //           path: '/utilities/color',
  //           iconText: 'C',
  //           auth: authRoles.admin,
  //         },
  //         {
  //           name: 'Spacing',
  //           path: '/utilities/spacing',
  //           iconText: 'S',
  //           auth: authRoles.admin,
  //         },
  //         {
  //           name: 'Typography',
  //           path: '/utilities/typography',
  //           iconText: 'T',
  //         },
  //         {
  //           name: 'Display',
  //           path: '/utilities/display',
  //           iconText: 'D',
  //         },
  //         {
  //           name: 'Position',
  //           path: '/utilities/position',
  //           iconText: 'P',
  //         },
  //         {
  //           name: 'Shadow',
  //           path: '/utilities/shadow',
  //           iconText: 'S',
  //         },
  //       ],
  //     },

  //     {
  //       name: 'Charts',
  //       icon: 'trending_up',
  //       children: [
  //         {
  //           name: 'Echarts',
  //           path: '/charts/echarts',
  //           iconText: 'E',
  //         },
  //         {
  //           name: "Recharts",
  //           path: "/charts/recharts",
  //           iconText: "R",
  //         },
  //         {
  //           name: 'React Vis',
  //           path: '/charts/react-vis',
  //           iconText: 'R',
  //         },
  //         {
  //           name: 'Victory Chart',
  //           path: '/charts/victory-charts',
  //           iconText: 'V',
  //         },
  //       ],
  //     },

  //     {
  //       name: 'Data Table',
  //       icon: 'table_view',
  //       children: [
  //         {
  //           name: 'CRUD Table',
  //           // icon: 'format_list_bulleted',
  //           path: '/crud-table',
  //         },
  //         {
  //           name: 'Simple Mui Table',
  //           path: '/data-table/simple-mui-table',
  //           iconText: 'T1',
  //         },
  //         {
  //           name: 'Expandable Mui Table',
  //           path: '/data-table/expandable-mui-table',
  //           iconText: 'T2',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Documentation',
  //       // icon: 'launch',
  //       type: 'extLink',
  //       path: 'http://demos.ui-lib.com/matx-react-doc/',
  //     },
  //   ]
  // },

  /////////////////////////////////
];
